var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyReportFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9997 2.9988H9.0009C8.20533 2.9988 7.44234 3.3149 6.87979 3.87755C6.31724 4.44021 6.0012 5.20333 6.0012 5.99904V30.001C6.0012 30.7967 6.31724 31.5598 6.87979 32.1224C7.44234 32.6851 8.20533 33.0012 9.0009 33.0012H26.9991C27.7947 33.0012 28.5577 32.6851 29.1202 32.1224C29.6828 31.5598 29.9988 30.7967 29.9988 30.001V11.9995M20.9997 2.9988C21.4745 2.99804 21.9447 3.09122 22.3834 3.27298C22.822 3.45474 23.2203 3.7215 23.5554 4.05789L28.9369 9.44032C29.2741 9.77561 29.5416 10.1744 29.7239 10.6137C29.9061 11.0529 29.9996 11.5239 29.9988 11.9995M20.9997 2.9988V10.4994C20.9997 10.8973 21.1577 11.2788 21.439 11.5601C21.7203 11.8415 22.1018 11.9995 22.4995 11.9995L29.9988 11.9995",
    stroke: "#071135",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReportFile);
export default __webpack_public_path__ + "static/media/empty-report-file.543e5d2d6ed804a79b74b022531597b2.svg";
export { ForwardRef as ReactComponent };